import { render, staticRenderFns } from "./proposals-promo.vue?vue&type=template&id=60a711f9&"
import script from "./proposals-promo.vue?vue&type=script&lang=js&"
export * from "./proposals-promo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a711f9')) {
      api.createRecord('60a711f9', component.options)
    } else {
      api.reload('60a711f9', component.options)
    }
    module.hot.accept("./proposals-promo.vue?vue&type=template&id=60a711f9&", function () {
      api.rerender('60a711f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion/proposals-promo.vue"
export default component.exports